(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const headers = document.querySelectorAll(".accordion-header");
  if (window.matchMedia("(max-width: 768px)").matches) {
    headers.forEach((header) => {
      header.classList.add("inactive");
      const content = header.nextElementSibling;
      content.style.display = "none";
    });

    headers.forEach((header) => {
      header.addEventListener("click", function () {
        const content = this.nextElementSibling;
        document.querySelectorAll(".accordion-header").forEach((otherHeader) => {
          if (otherHeader !== header) {
            otherHeader.classList.remove("active");
            otherHeader.classList.add("inactive");
            otherHeader.nextElementSibling.style.display = "none";
          }
        });
        if (content.style.display === "block") {
          content.style.display = "none";
          this.classList.remove("active");
          this.classList.add("inactive");
        } else {
          content.style.display = "block";
          this.classList.remove("inactive");
          this.classList.add("active");
        }
      });
    });
  }
});


  } catch(e) { console.error(e); }
})();
})();
